<template>
    <div class="container mescroll-touch">
        <div class="topdh" @click="back"><img src="../../assets/images/bjback.png"
                class="homeimg" />首页&nbsp;>&nbsp;会议日程详情
        </div>
        <div class="total">
            <img src="../../assets/images/bjtitle2.png" class="img" />
            <div class="rclist">
                <div class="toptip">
                    <div class="topback">
                        <div class="day">{{ list.DateStr2 }}</div>
                        <div class="tprow">
                            <div class="time"><img src="../../assets/images/dttime.png" class="icon" /><span>{{
                                list.StartTimeStr }} - {{ list.EndTimeStr }}</span></div>
                            <div class="address"><img src="../../assets/images/dtadd.png" class="icon1" /><span>{{
                                list.Address }}</span></div>
                        </div>
                        <div class="title">{{ list.Title }}</div>
                    </div>
                    <div class="topnoback">
                        <div class="nbrow">
                            <div class="zjzw">主席</div>
                        </div>
                        <div class="nbrow" v-for="(item, index) in list.Chairman" :key="index">
                            <div class="zjtouxiang">
                                <img :src="item.HeadUrl" class="tximg" />
                            </div>
                            <div class="namerow">
                                <div class="zjname">{{ item.Name }}</div>
                                <div class="zjhos">{{ item.Hospital }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tips" v-for="(item, index) in list.Detail" :key="index">
                    <div class="tipstop">
                        <img src="../../assets/images/bjline.png" class="tipspoint" />
                        <span class="tipstime">{{ item.StartTimeStr }} - {{ item.EndTimeStr }}</span>
                    </div>
                    <div class="tipsmain">
                        <div class="topnoback1">
                            <div class="nbrow1 nbtit">
                                {{ item.Title }}
                            </div>
                            <div class="nbrow1" v-for="(iitem, index) in item.Talker" :key="index">
                                <div class="zjtouxiang">
                                    <img :src="iitem.HeadUrl" class="tximg" />
                                </div>
                                <div class="namerow">
                                    <div class="zjname">{{ iitem.Name }}</div>
                                    <div class="zjhos">{{ iitem.Hospital }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <img src="../../assets/images/bjfooter.png" class="footerimg" />
        </div>
    </div>
</template>

<script>
import mixin from '../../common/mixin/mixins'
export default {
    name: 'bjwelcome',
    data() {
        return {
            Id: this.$route.query.Id,
            list: [],
        }
    },
    mixins: [mixin],
    created() {
        this.initbjShare();
        this.getdate()
        document.title = "第九届北京肿瘤防治研究会年会暨第十九届绿荫沙龙学术年会";
    },
    methods: {
        back() {
            this.$router.replace({ name: 'BJZL' })
        },
        getdate() {
            let that = this;
            this.$axios.get('/api/api/web/activity/GetSceduleDetail?id=' + that.Id).then(res => {
                that.list = res.Data;
                console.log(res.Data)
                // for (var d = 0; d < that.list.Detail.length; d++) {
                //     that.list.Detail[d].hasjb = false;
                //     that.list.Detail[d].haszcr = false;
                //     that.list.Detail[d].hasjz = false;
                //     for (var i = 0; i < that.list.Detail[d].Talker.length; i++) {
                //         // console.log(res.Data.Detail[d].Talker[i].TalkerType)
                //         let dtext = that.list.Detail[d].Talker[i]
                //         if (dtext.TalkerType == 1) {
                //             that.list.Detail[d].hasjb = true
                //         }
                //         if (dtext.TalkerType == 2) {
                //             that.list.Detail[d].haszcr = true
                //         }
                //         if (dtext.TalkerType == 3) {
                //             that.list.Detail[d].hasjz = true
                //         }
                //         console.log(this.list)
                //     }
                // }

            })
        },
    }
}
</script>

<style lang="scss" scoped>
body {
    -webkit-overflow-scrolling: unset
}

.container {
    // height: 100%;
    width: 100%;
    position: relative;
    -webkit-overflow-scrolling: unset // background: rgb(228, 236, 255);
}

.total {
    position: relative;
    height: 100%;
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.guanggaoimg {
    display: block;
    width: 90%;
    margin: 0.5rem auto;
}

.footerimg {
    display: block;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1;
}

.topdh {
    font-family: cursive;
    font-weight: bold;
    background-image: linear-gradient(to right, #01B671, #2D5EAA);
    color: #fff;
    padding: 0.3rem;
}

.homeimg {
    width: 5%;
    display: inline-block;
    vertical-align: text-bottom;
    margin-right: 0.1rem;
}

.mainimg {
    width: 100%;
    position: relative;
    z-index: 100;
    margin-bottom: 1.8rem;
}

.titletime {
    text-align: center;
    background-image: linear-gradient(to right, #1DA4BA, #2D5EAB);
    color: #fff;
    font-size: .5rem;
    padding: 0.2rem 0;
}

.innerlist {
    display: flex;
    flex-direction: row;
    padding: 0.4rem 0.5rem;
}

.innerlist:nth-child(odd) {
    background-color: #fff;
}

.innerlist:nth-child(even) {
    background-color: #E9F0F8;
}

.dateleft {
    display: flex;
    flex-direction: column;
    font-family: cursive;
    font-weight: bold;
    width: 90%;
    margin-right: 3%;
}

.dataright {
    width: 7%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.tarow {
    display: flex;
    flex-direction: row;
    font-size: .36rem;
    color: #9b9b9b;
}

.lefttitle {
    margin-bottom: .1rem;
    color: #3866AD;
    font-size: .43rem;
}

.lefttime {
    margin-right: .5rem;
}

.dtjt {
    display: block;
    width: 90%;
    margin: auto;
}

.rclist {
    margin-bottom: 2rem;
}

.toptip {
    width: 85%;
    margin: auto;
    box-shadow: 0 0 0.24rem 0.026667rem rgba(0, 0, 0, 0.2);
    background: #fff;
    z-index: 100;
    position: relative;
    border-radius: 0.5rem;
    box-sizing: border-box;
    margin-top: 0.5rem;
    overflow: hidden;
}

.topback {
    background-image: linear-gradient(to bottom, #1CA2BB, #277EB3);
    padding: 0.4rem;
    color: #fff;
}

.topnoback {
    padding: 0.4rem;
}

.day {
    font-size: .6rem;
}

.icon {
    width: 10%;
    display: block;
    margin-right: 0.15rem;
}

.icon1 {
    width: 5%;
    display: block;
    margin-right: 0.15rem;
}

.time {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 35%;
}

.address {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 65%;
}

.tprow {
    display: flex;
    flex-direction: row;
    font-size: .32rem;
    margin: .2rem 0;
}

.zjzw {
    display: inline-block;
    color: #fff;
    background: #2781B5;
    padding: 0 0.2rem;
    border-radius: 0.1rem;
}

.nbrow {
    display: flex;
    flex-direction: row;
    margin-bottom: 0.3rem;
}

.zjtouxiang {
    width: 1.3rem;
    height: 1.3rem;
    position: relative;
    overflow: hidden;
    border-radius: 50rem;
    margin-right: 0.3rem;
}

.tximg {
    display: block;
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.namerow {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.zjname {
    font-size: .45rem;
    margin-bottom: 0.1rem;
}

.zjhos {
    font-size: .37rem;
}

.nbrow1 {
    display: flex;
    flex-direction: row;
    margin-bottom: 0.3rem;
}

.tips {
    width: 85%;
    margin: auto;
    margin-top: 0.5rem;
    position: relative;
}

.tipspoint {
    display: inline-block;
    width: 4%;
    vertical-align: middle;
    margin-right: 0.15rem;
}

.tipstime {
    vertical-align: middle;
}

.tipsmain {
    border-left: 1px solid #2781B5;
    margin-left: 0.15rem;
    margin-top: 0.1rem;
}

.topnoback1 {
    width: 93%;
    margin: auto;
    box-shadow: 0 0 0.24rem 0.02667rem rgba(0, 0, 0, 0.2);
    background: #fff;
    z-index: 100;
    position: relative;
    border-radius: 0.5rem;
    box-sizing: border-box;
    margin-top: 0.4rem;
    overflow: hidden;
    padding: 0.3rem;
}

.nbtit {
    font-size: .45rem;
}
</style>